import React from 'react';
import { useAppSelector } from '../../../app/hooks'

import styled from 'styled-components'

const Wrapper = styled.article`
  .alert {
    padding: 0.375rem 0.75rem;
    margin-bottom: 1rem;
    border-color: transparent;
    border-radius: var(--borderRadius);
    text-align: center;
    letter-spacing: var(--letterSpacing);
  }

  .alert-danger {
    color: var(--red-dark);
    background: var(--red-light);
  }
  .alert-warn {
    color: var(--red-dark);
    background: var(--red-light);
  }
  .alert-success {
    color: var(--green-dark);
    background: var(--green-light);
  }
`

export const Alert = () => {
    const appstate= useAppSelector(state => state.appstate);
    
  return <Wrapper>
    <div className={`alert alert-${appstate.alertType}`}>{appstate.alertText}</div>
  </Wrapper>
}